import React, { createContext, useContext } from 'react';

import type { CustomFunctions } from '../engine/functionExecutor.ts';
import type { SurfaceState, SurfaceAction } from '../state/surfaceStore.ts';

export type ActionCallback = (action: {
	context?: Record<string, unknown>;
	dataModel: Record<string, unknown>;
	eventName: string;
	surfaceId: string;
}) => void;

export type SurfaceContextValue = {
	customFunctions?: CustomFunctions;
	dispatch: React.Dispatch<SurfaceAction>;
	onAction: ActionCallback;
	state: SurfaceState;
};

export const SurfaceContext: React.Context<SurfaceContextValue | null> =
	createContext<SurfaceContextValue | null>(null);

export function useSurfaceContext(): SurfaceContextValue {
	const context = useContext(SurfaceContext);
	if (!context) {
		throw new Error('useSurfaceContext must be used within A2UISurface');
	}
	return context;
}
